import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { CDropDown } from "@appcues/component-library";
import { baseTheme } from "@appcues/theme-utilities";

const ThemeDropDown = ({ label, draftTheme, setDraftTheme }) => {
  const handleChange = useCallback(
    value => {
      const labelName = label.name;
      setDraftTheme(prevDraftTheme => {
        return { ...prevDraftTheme, [labelName]: value };
      });
    },
    [setDraftTheme]
  );

  return (
    <CDropDown
      options={label.options}
      value={draftTheme[label.name] || baseTheme[label.name]}
      onChange={handleChange}
      marginRight={24}
      minWidth={168}
    />
  );
};

ThemeDropDown.propTypes = {
  label: PropTypes.object.isRequired,
  draftTheme: PropTypes.object.isRequired,
  setDraftTheme: PropTypes.func.isRequired
};

export default ThemeDropDown;
